import { Map, OrderedMap, fromJS } from 'immutable';

import MeetingItemsConstants from 'Shared/constants/MeetingItems.constants';
import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';
import WorkspaceItemCommentsConstants from 'Shared/constants/WorkspaceItemComments.constants';
import WorkspaceRecentUpdatesConstants from '../constants/WorkspaceRecentUpdates.constants';
import HomePageConstants from '../constants/HomePage.constants';

const initialState = Map({
  [MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG]: OrderedMap(),
  [MeetingItemsConstants.State.ACTION_ITEM_IDS_BY_WORKSPACE_SLUG]: OrderedMap(),
  [MeetingItemsConstants.State.ACTION_ITEM_IDS_BY_GOAL_SLUG]: OrderedMap(),
  [MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG]: OrderedMap(),
});

export const MeetingItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MeetingItemsConstants.Actions.UPDATE_HIGH_PRIORITY_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_COMPLETE_STATUS_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_DUE_BY_SUCCESS:
    case MeetingItemsConstants.Actions.FETCH_MEETING_ITEMS_SUCCESS:
    case MeetingItemsConstants.Actions.FETCH_SINGLE_MEETING_ITEMS_SUCCESS:
    case MeetingItemsConstants.Actions.ATTACH_FILE_SUCCESS:
    case MeetingItemsConstants.Actions.DELETE_FILE_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_SHOW_PREVIEW_SUCCESS:
    case MeetingItemsConstants.Actions.DELETE_RECURRENCE_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_RECURRENCE_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_ASSIGNEE_SUCCESS:
    case MeetingItemsConstants.Actions.CREATE_ASANA_TASK_SUCCESS:
    case MeetingItemsConstants.Actions.DISCONNECT_ASANA_TASK_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_ITEM_BODY_SUCCESS:
    case MeetingItemsConstants.Actions.CREATE_NEW_MEETING_ITEM_SUCCESS:
    case WorkspaceItemCommentsConstants.Actions.CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS:
    case MeetingItemsConstants.Actions.REMOVE_NESTING_SUCCESS:
    case MeetingItemsConstants.Actions.UPDATE_PARENT_UUID_SUCCESS:
    case MeetingItemsConstants.Actions.ADD_TO_GOAL_SUCCESS:
    case MeetingItemsConstants.Actions.CONVERT_DISCUSSION_TOPIC_AND_ACTION_ITEM:
    case MeetingItemsConstants.Actions.REMOVE_FROM_GOAL_SUCCESS:
    case WorkspaceRecentUpdatesConstants.Actions.FETCH_RECENT_UPDATES_SUCCESS:
    case HomePageConstants.Actions.FETCH_HOME_PAGE_DATA_SUCCESS:
      return state.updateIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          OrderedMap(
            Object.values(action.payload.meetingItem).map(item => {
              if (existing.has(item.id)) {
                return [item.id, existing.get(item.id).merge(Map(fromJS(item.attributes)))];
              }
              return [item.id, Map(fromJS(item.attributes))];
            })
          )
        )
      );

    // catch action cable and update items in new store
    case 'MEETING_ITEMS_SYNC':
      return state
        .updateIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG], (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              [...(action.meetingItems || []), ...(action.discussionTopics || [])].map(item => {
                if (existing.has(item.uuid)) {
                  return [item.uuid, existing.get(item.uuid).merge(Map(fromJS(item)))];
                }
                return [item.uuid, Map(fromJS(item))];
              })
            )
          )
        )
        .updateIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG], exisiting =>
          exisiting.deleteAll(
            state
              .get(MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG)
              .filter(item =>
                action.deletedDiscussionTopics.find(
                  ({ id }) => id === MeetingItemHelpers.getId(item) || id === MeetingItemHelpers.getParentId(item)
                )
              )
              .keySeq()
              .toJS()
          )
        );

    case MeetingItemsConstants.Actions.FETCH_WORKSPACE_ACTION_ITEMS_SUCCESS:
      return state.setIn(
        [MeetingItemsConstants.State.ACTION_ITEM_IDS_BY_WORKSPACE_SLUG, action.payload.workspaceSlug],
        action.payload.data.map(item => item.id)
      );
    case MeetingItemsConstants.Actions.FETCH_GOAL_ACTION_ITEMS_SUCCESS:
      return state.updateIn(
        [MeetingItemsConstants.State.ACTION_ITEM_IDS_BY_GOAL_SLUG, action.payload.goalSlug],
        (existing = []) => existing.concat(action.payload.data.map(item => item.id))
      );
    case MeetingItemsConstants.Actions.DELETE_MEETING_ITEM_SUCCESS:
      return state
        .deleteIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG, action.payload.meetingItemSlug])
        .deleteIn([MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG, action.payload.meetingItemSlug])
        .updateIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG], exisiting =>
          exisiting.deleteAll(
            state
              .get(MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG)
              .filter(item => MeetingItemHelpers.getParentUuid(item) === action.payload.meetingItemSlug)
              .keySeq()
              .toJS()
          )
        );
    case 'MEETING_ITEM_REMOVE_REQUEST':
      return state
        .deleteIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG, action.payload.uuid])
        .deleteIn([MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG, action.payload.uuid])
        .updateIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG], exisiting =>
          exisiting.deleteAll(
            state
              .get(MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG)
              .filter(item => MeetingItemHelpers.getParentUuid(item) === action.payload.uuid)
              .keySeq()
              .toJS()
          )
        );
    case MeetingItemsConstants.Actions.UPDATE_ITEM_BODY_IN_REDUX:
      return state.setIn(
        [
          MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG,
          action.payload.meetingItemSlug,
          MeetingItemsConstants.Model.BODY,
        ],
        action.payload.body
      );
    case MeetingItemsConstants.Actions.CREATE_NEW_TEMP_MEETING_ITEM_SUCCESS:
      return state.setIn(
        [MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG, action.payload.uuid],
        Map(fromJS(action.payload))
      );
    case MeetingItemsConstants.Actions.CLEAR_TEMP_MEETING_ITEM_SUCCESS:
      return state.set(MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG, OrderedMap());
    case MeetingItemsConstants.Actions.DELETE_TEMP_MEETING_ITEM_SUCCESS:
      return state.deleteIn([MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG, action.payload]);
    case MeetingItemsConstants.Actions.REMOVE_NESTING_OF_TEMP_ITEM_SUCCESS:
      return state
        .deleteIn([
          MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG,
          action.payload.uuid,
          MeetingItemsConstants.Model.PARENT_ID,
        ])
        .deleteIn([
          MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG,
          action.payload.uuid,
          MeetingItemsConstants.Model.PARENT_UUID,
        ])
        .setIn(
          [
            MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG,
            action.payload.uuid,
            MeetingItemsConstants.Model.AFTER_UUID,
          ],
          action.payload.afterUuid
        );
    case MeetingItemsConstants.Actions.NEST_TEMP_ITEM_SUCCESS:
      return state
        .setIn(
          [
            MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG,
            action.payload.uuid,
            MeetingItemsConstants.Model.PARENT_UUID,
          ],
          action.payload.parentUuid
        )
        .setIn(
          [
            MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG,
            action.payload.uuid,
            MeetingItemsConstants.Model.PARENT_ID,
          ],
          action.payload.parentId
        )
        .setIn(
          [
            MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG,
            action.payload.uuid,
            MeetingItemsConstants.Model.AFTER_UUID,
          ],
          action.payload.afterUuid
        );
    case MeetingItemsConstants.Actions.DELETE_TEMP_ITEM_SUCCESS:
      return state.deleteIn([MeetingItemsConstants.State.TEMP_ACTION_ITEM_IDS_BY_SLUG, action.payload.uuid]);
    // Handle case when Item is moved to a new workspace from the old components
    case 'DUPLICATE_ACROSS_WORKSPACES_RESPONSE':
      if (action.payload.isMoveItems)
        return state.updateIn([MeetingItemsConstants.State.MEETING_ITEMS_BY_ITEM_SLUG], exisiting =>
          exisiting.deleteAll(action.payload.data.map(item => item.uuid))
        );
      else return state;

    default:
      return state;
  }
};
